
import React from "react";
import { FormFieldType } from "@/types/form";
import { useTranslation } from "react-i18next";
import { tField } from "../utils/i18nField";

interface SectionHeaderProps {
  element: FormFieldType;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ element }) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6">
      <h2 className="text-xl font-semibold border-b border-gray-200 pb-2">{tField(t, element.label)}</h2>
    </div>
  );
};

export default SectionHeader;
